module.exports = __webpack_public_path__ + "media/images/recruitment/landing/price02_sp-4b7d3b2262ac020b5ac2b32731f5643c.svg";